import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { CamionSucursalService } from 'src/app/services/camion-sucursal.service';
import { ChoferSucursalService } from 'src/app/services/chofer-sucursal.service';
import { MercaderiaFueraRutaService } from 'src/app/services/mercaderia-fuera-ruta.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RetornoMecaderiaComponentModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';

@Component({
  selector: 'app-retorno-mercaderia',
  templateUrl: './retorno-mercaderia.component.html',
  styleUrls: ['./retorno-mercaderia.component.scss'],
  providers: [SecurityService],
})
export class RetornoMercaderiaComponent implements OnInit {

  // Modales
  @ViewChild(RetornoMecaderiaComponentModalAddEditComponent, { static: true }) modalAddEditRetorno: RetornoMecaderiaComponentModalAddEditComponent

  // Form
  formHeader: FormGroup

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  loading: boolean = false
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  productoSeleccionado: any = null

  optionsChofer: Array<any> = [];
  optionsCamion: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private choferSucursalService: ChoferSucursalService,
    private camionSucursalService: CamionSucursalService,
    private mercaderiaFueraRutaService: MercaderiaFueraRutaService,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
  ) {
    this.log = this.clog.log('RETORNO-MERCADERIA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadChofer()
    this.loadCamion()

    this.createForm()
  }

  loadChofer() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1,
      }
    }
    this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const { registros } = respuesta; //.registros.filter(p => p.estado);
        this.optionsChofer = registros.map(p => ({ value: p.rut, label: p.nombre, ...p }))
      })
  }

  loadCamion() {
    this.camionSucursalService.obtenerCamionSucursalxRutEmpresaSucursal(
      {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1
      }, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const { registros } = respuesta; //.registros.filter(p => p.estado);
        this.optionsCamion = registros.map(p => ({ value: p.patente, label: p.descripcion, ...p }))
      })
  }

  private createForm() {
    const now = this.datesService.CurrentDateToShortTimeString()
    this.log('now', now)
    this.formHeader = this.fb.group({
      chofer: [[]],
      camion: [[]],
      fecha: [now],
    });
  }

  showModalAdd() {
    this.modalAddEditRetorno.showNew()
  }

  showModalView(mov) {
    this.modalAddEditRetorno.showView(mov)
  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null

    const { chofer, camion, fecha } = this.formHeader.value
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      listaChoferes: chofer,
      listaCamiones: camion,
      fechaRegistro: fecha ? fecha : null,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.mercaderiaFueraRutaService.obtenerxEmpresaXSucursalxChoferxCamion(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMovimientos = registros

      this.listaMovimientos.forEach(mov => {
        mov.rutClienteFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      });

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

}
